import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, getToken, errMsg } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, object=user
  useEffect(() => {
    if (!getToken()) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data.user))
      .catch(() => {
        setToken(null);
        setUser(false);
      });
  }, []);

  async function login(identifier, password) {
    const r = await api.post("/auth/login", { identifier, password });
    setToken(r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  }
  async function logout() {
    setToken(null);
    setUser(false);
    try { await api.post("/auth/logout"); } catch {}
  }

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, errMsg }}>
      {children}
    </AuthContext.Provider>
  );
}
